import { Popover, Tooltip } from '@tecsinapse/cortex-react'
import React, { Dispatch, ReactNode, SetStateAction } from 'react'
import { BsFillQuestionCircleFill } from 'react-icons/bs'
import { dropdownVariants } from '../styles'
import { DropdownActionProps, DropdownPlacement } from '../utils'
import Loading from './Loading'

interface DropdownProps {
  controlled: boolean
  isOpen?: boolean
  setIsOpen?: Dispatch<SetStateAction<boolean>>
  loading?: boolean
  title?: string
  actions: DropdownActionProps[]
  trigger: ReactNode
  placement?: DropdownPlacement
}

const { item, titlePopper, containerActions, containerLabel, icon } = dropdownVariants()

const Dropdown = ({ controlled, isOpen, setIsOpen, loading, title, actions, trigger, placement }: DropdownProps) => (
  <Popover.Root
    controlled={controlled ? true : false}
    isOpen={isOpen}
    setIsOpen={setIsOpen}
    placement={placement}
    trigger='click'
  >
    <Popover.Trigger>
      <>{trigger}</>
    </Popover.Trigger>
    <Popover.Content className={'bg-white'}>
      {title ? <div className={titlePopper()}>{title}</div> : <></>}
      {loading ? (
        <Loading />
      ) : (
        <div className={containerActions()}>
          {actions.map((it, idx) => (
            <div key={it.label}>
              <div
                className={item()}
                onClick={e => {
                  e.stopPropagation()
                  it.onClick()
                  setIsOpen?.(false)
                }}
              >
                {it.icon ? (
                  <div
                    key={idx}
                    className={icon()}
                  >
                    {it.icon}
                  </div>
                ) : (
                  <></>
                )}
                <div className={containerLabel()}>
                  <span className={it.labelStyle ?? ''}>{it.label}</span>
                  {it.tooltipTitle ? (
                    <div>
                      <Tooltip
                        width={345}
                        text={it.tooltipTitle}
                        placement='right'
                      >
                        <BsFillQuestionCircleFill className={'text-deca text-dark'} />
                      </Tooltip>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              {it.children}
            </div>
          ))}
        </div>
      )}
    </Popover.Content>
  </Popover.Root>
)

export default Dropdown
